/* Replace shortcode - [HYPHEN] with &shy; */
export const convertShortcodeHyphen = (text: string) => {
  const shortcode = '[HYPHEN]';
  const indexStart = text.indexOf(shortcode);
  if (indexStart !== -1) {
    return text.split(shortcode).join('&shy;');
  }
  return text;
};
